import { ComponentProps } from "react";
import { TilesV2 } from "@components";

import type { ProductOptionPickerProps } from "..";

import TilesGraphicOptionV2 from "./TilesGraphicOptionV2";
import TilesGraphicSquareOptionV2 from "./TilesGraphicSquareOptionV2";
import TilesSwatchOptionV2 from "./TilesSwatchOptionV2";

type TilesRenderMethod = ComponentProps<typeof TilesV2>["renderOption"];
const renderMethodsV2: Partial<
  Record<NonNullable<ProductOptionPickerProps["type"]>, TilesRenderMethod>
> = {
  swatch: TilesSwatchOptionV2,
  graphic: TilesGraphicOptionV2,
  "graphic-square": TilesGraphicSquareOptionV2,
};

export default renderMethodsV2;
